module.exports = __webpack_public_path__ + "static/media/filter-active.7416db75.svg";